import styled from "@emotion/styled";

interface IProps {
	color?: string;
	backgroundColor?: string;
}

export const PrimaryButton = styled.button<IProps>`
	background: ${(props) => props.backgroundColor || "#ff583e"};
	color: ${(props) => props.color || "#ffffff"};
	height: 50px;
	width: calc(100% - 50px);
	max-width: 320px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	line-height: 1;
	border-radius: 60px;
	box-shadow: none;
	border: none;
	margin: 15px auto 35px;
	font-weight: bold;
`;
